module.exports = __webpack_public_path__ + "img/es-back.e9215828.png";